<template>
  <SelectMenu :items="items"
    :selected-key="selectedIndex"
    :placeholder="placeholder"
    :disabled="disabled"
    :loading="loading"
    @pick="onPick" />
</template>

<script>
import SelectMenu from './SelectMenu.vue'

export default {
  name: 'select-input',
  components: { SelectMenu },
  emits: ['update:modelValue'],
  props: {
    modelValue: { type: [String, Number, Boolean, null], default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: '— Puudub —' },
    clearable: { type: Boolean, default: true },
    labelKey: { type: String, default: 'name' },
    valueKey: { type: String, default: 'id' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    // Keyed by index, so number ids stay numbers and any value type can be matched.
    selectedIndex() {
      const i = this.options.findIndex((o) => o[this.valueKey] === this.modelValue)
      return i === -1 ? '' : i
    },
    items() {
      const items = this.options.map((opt, i) => ({ key: i, label: opt[this.labelKey] }))
      return this.clearable ? [{ key: '', label: this.placeholder, muted: true }, ...items] : items
    },
  },
  methods: {
    onPick(item) {
      this.$emit('update:modelValue', item.key === '' ? null : this.options[item.key][this.valueKey])
    },
  },
}
</script>
